<template>
    <form @submit.prevent="requestRestore" class="form-restore">
        <template v-if="!sended && !codeVerified">
            <h1 class="h3 mb-3 font-weight-normal">{{ $t('Забыл пароль') }}</h1>

            <p class="restore-description">
                {{ $t('forgot_password_desc') }}
            </p>

            <div class="form-group">
                <label for="inputEmail" class="sr-only">{{ $t('Email') }}</label>
                <input type="email"
                        id="inputEmail"
                        :class="{'form-control': true, 'is-invalid': hasError('login')}"
                        placeholder="Email"
                        required
                        v-model="form.login"
                        autofocus />
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('login')" v-text="getError('login')"></span>

            <button class="btn btn-blue btn-block" :disabled="form.login === null || form.login === '' || form.login.indexOf('@') === -1" type="submit">{{ $t('Отправить') }}</button>
        </template>

        <template v-if="sended && !codeVerified">
            <h1 class="h3 mb-3 font-weight-normal">{{ $t('Письмо отправлено') }}</h1>

            <div class="alert alert-success">
                <p class="m-0">
                    {{ $t('send_forgot_password_desc') }}
                </p>
            </div>
        </template>

        <template v-if="codeVerified">
            <h1 class="h3 mb-3 font-weight-normal">{{ $t('Новый пароль') }}</h1>

            <p class="restore-description">
                {{ $t('Введите новый пароль который вы будете использовать для входа в дальнейшем') }}
            </p>

            <div class="form-group">
                <label for="inputPassword" class="sr-only">{{ $t('Пароль') }}</label>
                <input type="password"
                        id="inputPassword"
                        :class="{'form-control': true, 'is-invalid mb-1': hasError('password')}"
                        :placeholder="$t('Пароль')"
                        v-model="form.password"
                        required />
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('password')" v-text="getError('password')"></span>

            <div class="form-group">
                <label for="inputPasswordConfirmation" class="sr-only">{{ $t('Повторите пароль') }}</label>
                <input type="password"
                        id="inputPasswordConfirmation"
                        class="form-control"
                        :placeholder="$t('Повторите пароль')"
                        v-model="form.password_confirmation"
                        required />
            </div>

            <button class="btn btn-blue btn-block" type="submit">{{ $t('Далее') }}</button>
        </template>

        <router-link to="/login" class="btn btn-link text-center">{{ $t(!codeVerified ? 'Назад' : 'Отмена') }}</router-link>
    </form>
</template>

<script>
import { EventBus } from '@/event-bus.js';

export default {
    name: "Restore",

    data: function() {
        return {
            form: {
                login: null,
                code: null,
                password: null,
                password_confirmation: null,
            },

            sended: false,
            codeVerified: false,

            errors: {},
        };
    },

    watch: {
        'form.login': function() {
            delete this.errors['login'];
        },
    },

    mounted() {
        let code = location.hash.replace('#', '');

        if(code !== "" && code !== "#") {
            this.form.code = code;
            this.checkCode();
        }
    },

    methods: {
        checkCode() {
            axios.post('/restore/code', this.form)
                .then(({data}) => {
                    this.codeVerified = true;
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : this.$t('Неизвестная ошибка'), 'error');   
                    }

                    EventBus.$emit('show-alert', this.$t('Ссылка неактивна или уже была использована'), 'error');
                    location.hash = "";

                    this.errors = response.data.data;
                });
        },

        changePassword() {
            axios.post('/restore/password', this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', this.$t('Вы можете использовать новый пароль для входа'), 'success');

                    this.$router.push(`/login`);
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : this.$t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        requestRestore() {
            if(this.codeVerified) {
                return this.changePassword();
            }

            axios.post(`/restore`, this.form)
                .then(({data}) => {
                    this.sended = true;
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : this.$t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
};
</script>

<style scoped lang="scss">
.restore-description {
    font-size: 14px;
}
</style>